var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "signup-screen" }, [
    _c("h2", { staticClass: "mb-4" }, [_vm._v("\n    Account Sign Up\n  ")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "signup-form has-border" },
      [
        _c(
          "b-form-group",
          [
            _c("label", { attrs: { for: "user-name" } }, [_vm._v("Username")]),
            _vm._v(" "),
            _c("b-form-input", {
              attrs: { id: "user-name", size: "md", type: "text" },
              model: {
                value: _vm.userName,
                callback: function($$v) {
                  _vm.userName = $$v
                },
                expression: "userName"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-form-group",
          [
            _c("label", { attrs: { for: "email-id" } }, [_vm._v("Email")]),
            _vm._v(" "),
            _c("b-form-input", {
              attrs: { id: "email-id", size: "md", type: "text" },
              model: {
                value: _vm.emailAddress,
                callback: function($$v) {
                  _vm.emailAddress = $$v
                },
                expression: "emailAddress"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-form-group",
          [
            _c("label", { attrs: { for: "ph-no" } }, [_vm._v("Phone")]),
            _vm._v(" "),
            _c("b-form-input", {
              attrs: {
                id: "ph-np",
                size: "md",
                type: "text",
                placeholder: "Enter phone number"
              },
              on: { change: _vm.handlePhoneNumberChange },
              model: {
                value: _vm.phoneNumber,
                callback: function($$v) {
                  _vm.phoneNumber = $$v
                },
                expression: "phoneNumber"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-form-group",
          [
            _c("label", { attrs: { for: "password" } }, [_vm._v("Password")]),
            _vm._v(" "),
            _c("b-form-input", {
              attrs: { id: "password", size: "md", type: "text" },
              model: {
                value: _vm.password,
                callback: function($$v) {
                  _vm.password = $$v
                },
                expression: "password"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("b-form-group", [
          !!_vm.error
            ? _c(
                "div",
                {
                  staticClass: "mr-4 alert alert-danger fade show",
                  attrs: { role: "alert" }
                },
                [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "ml-2 d-flex flex-nowrap align-content-end align-items-end"
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "ml-2 mr-2",
                  attrs: { title: "Cancel", disabled: _vm.loading },
                  on: { click: _vm.onCancel }
                },
                [_vm._v("\n          Cancel\n        ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", title: "Sign Up" },
                  on: {
                    click: _vm.onSubmitSignUpForm,
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        $event.keyCode !== 13
                      ) {
                        return null
                      }
                      return _vm.onSubmitSignUpForm($event)
                    }
                  }
                },
                [_vm._v("\n          Sign Up\n        ")]
              )
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4 d-flex" }, [
      _vm._v("\n    Temporary functionality to make an account"),
      _c("br"),
      _vm._v("\n    For testing\n  ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }